<template>
  <v-card class="mb-4"
          v-if="documents.length">
    <v-card-title class="pb-0 text-truncate">
      {{ documents.length }} Selected {{ documents.length | pluralize('Document', false) }}
    </v-card-title>
    <v-list dense
            class="pa-0 mt-0">
      <template v-for="(document, index) in documents">
        <v-list-item :key="document.id">
          <v-list-item-content v-if="isDemo">
            <v-list-item-title>
              *****************
            </v-list-item-title>
            <v-list-item-subtitle>
              XYZ-*********-v{{ index + 1}}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-list-item-title>
              {{ document.display_name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ document.document_id }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon
                   @click.prevent="removeFromCart(document)">
              <v-icon>
                fal fa-times
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="index < (documents.length - 1)"></v-divider>
      </template>
    </v-list>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters('pepperFlowCart', [
      'connection', // MLD-2944
      'documents',
    ]),
    isDemo() { // MLD-2944
      return this.connection === 'demo_vault';
    }
  },
  methods: {
    removeFromCart(document) {
      this.$store.dispatch('pepperFlowCart/removeDocument', document);
    },
  }
}
</script>
